const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const config = isLocalhost ? {
    app_name:'咕噜咕噜变',
    api_url: 'http://localhost:5800',
    upload_port: '5801',
    picture_url: '/upload/images/',
} : {
    app_name:'咕噜咕噜变',
    api_url: process.env.REACT_APP_API_URL || window.location.origin,
    upload_port: '5811',
    picture_url: '/upload/images/',
}
